import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import axios from 'axios';
import {databaseUrl} from '../../server/server';
import { createContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="http://happycall.biz">
        chek Web
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
const defaultTheme = createTheme();

export default function SignUp() {
    const navigate = useNavigate();
    const [id,setId] = React.useState('');
    const [name,setName] = React.useState('');
    const [password,setPassword] = React.useState('');

    const inputId = (event) => {
        setId(event.target.value);
    }
    const inputName = (event) => {
        setName(event.target.value)
    }
    const inputPassword = (event) => {
        setPassword(event.target.value)
    }
  const handleSubmit = (event) => {
    event.preventDefault();


    if(id.trim().length < 2){
      return alert(`ID 2 문자 이상 입력하세요`);
    }
    if(name.trim().length < 2){
      return alert(`이름 입력 해야 합니다`);
    }
    if(password.length < 2){
      return alert(`password 2자 이상 입력하세요`);
    }
    axios.post(`${databaseUrl}/users/create`,{
          userid:id,
          username:name,
          password:password
    },{
      headers: {'content-Type':'application/json'}
    }).then(function(response){
      if(response.data.completed === 'completed'){
        alert(`completed, Go to Log In PAGE`);
      }
      navigate('/SignIn'); // 초기 페이지로 이동
    }).catch(function(error){
      console.log(error);
    })
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              ID : 2글자 이상 영문 또는 숫자
              <Grid item xs={12} >
                <TextField
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="ID"
                  autoFocus
                  onChange={inputId}
                />
              </Grid>
              <br></br><br></br>
              NAME : 이름
              <Grid item xs={12} >
                <TextField
                  required
                  fullWidth
                  id="lastName"
                  label="Your NAME"
                  name="lastName"
                  autoComplete="family-name"
                  onChange={inputName}
                />
              </Grid>
              <br></br><br></br>
              PW : 2글자 이상 숫자 영문 또는 숫자
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                  onChange={inputPassword}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign Up
            </Button>
                <Link to="/SignIn" variant="body2">
                  Already have an account? Sign in
                </Link>
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}